import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { UserCog, Mail, Lock, LogIn } from 'lucide-react';
import { toast } from 'sonner';
import api from '@/utils/api';

const KasirLogin = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await api.post('/auth/login', formData);
      
      if (response.data.user.role !== 'kasir') {
        toast.error('Akses ditolak. Hanya kasir yang dapat login.');
        return;
      }

      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
      toast.success('Login kasir berhasil!');
      navigate('/kasir/booking');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Login gagal');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-md"
      >
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-secondary/10 rounded-full mb-4">
            <UserCog className="w-8 h-8 text-secondary" />
          </div>
          <h1 className="text-3xl font-heading font-bold uppercase text-white mb-2">Kasir Login</h1>
          <p className="text-zinc-400">Masuk ke sistem kasir Zero Futsal</p>
        </div>

        <div className="bg-zinc-900 border border-zinc-800 rounded-lg p-8">
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label className="block text-sm font-semibold text-zinc-300 mb-2">Email Kasir</label>
              <div className="relative">
                <Mail className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-zinc-500" />
                <input
                  data-testid="kasir-email-input"
                  type="email"
                  required
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  className="w-full bg-zinc-950 border border-zinc-800 focus:border-secondary focus:ring-1 focus:ring-secondary text-white rounded-md h-12 pl-12 pr-4 placeholder:text-zinc-600 transition-all outline-none"
                  placeholder="kasir@zerofutsal.com"
                />
              </div>
            </div>

            <div>
              <label className="block text-sm font-semibold text-zinc-300 mb-2">Password</label>
              <div className="relative">
                <Lock className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-zinc-500" />
                <input
                  data-testid="kasir-password-input"
                  type="password"
                  required
                  value={formData.password}
                  onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                  className="w-full bg-zinc-950 border border-zinc-800 focus:border-secondary focus:ring-1 focus:ring-secondary text-white rounded-md h-12 pl-12 pr-4 placeholder:text-zinc-600 transition-all outline-none"
                  placeholder="••••••••"
                />
              </div>
            </div>

            <button
              data-testid="kasir-login-submit-btn"
              type="submit"
              disabled={loading}
              className="w-full bg-secondary text-white hover:bg-secondary-hover rounded-none skew-btn px-8 py-3 font-bold uppercase tracking-wider transition-all duration-200 shadow-[4px_4px_0px_0px_#FFFFFF] hover:shadow-[6px_6px_0px_0px_#FFFFFF] disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
            >
              <span>{loading ? 'Memproses...' : 'Masuk Kasir'}</span>
              {!loading && <LogIn className="w-5 h-5" />}
            </button>
          </form>

          <div className="mt-6 text-center">
            <Link to="/" className="text-zinc-400 hover:text-secondary text-sm">
              ← Kembali ke halaman utama
            </Link>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default KasirLogin;